import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll position to the top of the page every time the route
// changes. React Router doesn't do this automatically (unlike a real
// full-page navigation), so without this, clicking a link while scrolled
// down on the previous page lands you scrolled down on the new page too —
// this is the "page opens from the bottom" bug reported across several
// pages (category banners, product cards, checkout).
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;